import Vue from 'vue'
import App from './App.vue'
import URL from 'url-parse'
import { createStore } from './stores/store'
import { login } from '../modules/firebase/core'
import './icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueYoutube from 'vue-youtube'
import VueAnime from 'vue-animejs'

import '../registerServiceWorker'

Vue.component('faicon', FontAwesomeIcon)
Vue.component('scrollview', VuePerfectScrollbar)
Vue.config.productionTip = false
Vue.use(VueYoutube)
Vue.use(VueAnime)

// 32 bit FNV-1a hash
// ref: http://isthe.com/chongo/tech/comp/fnv/
function fnv32a(_str, padding = true) {
  /*eslint no-bitwise: 0 */
  const FNV1_32A_INIT = 0x811c9dc5
  let hval = FNV1_32A_INIT
  let str = _str + ''
  for (let i = 0; i < str.length; ++i) {
    hval ^= str.charCodeAt(i)
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24)
  }
  let hashstr = (hval >>> 0).toString(16)
  if (padding) {
    hashstr = ('00000000' + hashstr).slice(-8)
  }
  return hashstr
}

async function launchApp() {
  const user = await login()
  const url = new URL(location.href, true)
  const room = url.query.room ? url.query.room : user.uid
  const store = createStore(room)

  url.set('query', { room })
  history.replaceState({}, document.title, url.toString())

  store.commit('local/restore', room)
  store.commit('local/set', { key: 'uid', value: user.uid })

  if (process.env.NODE_ENV !== 'development') {
    store.dispatch('members/$insert', { key: user.uid, data: { characterKey: null } })
    setTimeout(() => {
      store.dispatch('messages/log', `${fnv32a(user.uid)}さんが入室しました。`)
    }, 2000)
  }
  new Vue({
    render: h => h(App),
    store
  }).$mount('#app')
}

launchApp()